import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs';

import { ConfigurationService } from '@mobi/rwc-utils-common-ng-jslib';

export interface MobiTopology {
    api_discovery_uri: string;
    business_idp_metadata_uri: string;
}

@Injectable({ providedIn: 'root' })
export class TopologyIntegrationService {
    // no extra headers must be set on the topology request
    #httpClient = new HttpClient(inject(HttpBackend)); // avoid all http interceptors
    #topologyUrl = inject(ConfigurationService).getSync('topologyEndpoint') as string;

    readonly topology$ = this.#httpClient.get<MobiTopology>(this.#topologyUrl).pipe(shareReplay(1));
}
